export default __webpack_public_path__ + "static/media/prepaidPlanLogo.ca8c0e09.svg";